import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    link: {
      color: palette.darkGray,
      cursor: 'pointer',
      marginRight: 2,
      textDecoration: 'none',
      marginLeft: 2,
      '&:hover': {
        textDecoration: 'underline',
        opacity: 0.7,
      },
    },
    name: {
      marginLeft: 4,
    },
  });
